var $container;
var itemSelector;
var responsiveIsotope = [
    [480, 2],
    [850, 4]
];
var itemsPerPageDefault = 8;
var itemsPerPage = defineItemsPerPage();
var currentNumberPages = 1;
var currentPage = 1;
var currentFilter = '*';
var filterAtribute = 'data-filter';
var pageAtribute = 'data-page';
var pagerClass = 'isotope-pager';

function videoGalleryOnInit(){
    initVideoGallery();
}

function videoGalleryOnComplete(){
    initVideoGallery();
}

function initVideoGallery(){

    if(jQuery('.video-gallery-wrapper')[0]){


        currentFilter = '*';

        itemSelector = '.single-video';

        $container = jQuery('.video-gallery-wrapper').isotope({
            itemSelector: itemSelector,
            layoutMode: 'fitRows',
            filter: '*',
            fitRows: {
                gutter: '.block.video-gallery .spacer'
            }
        });

        $container.imagesLoaded().progress( function() {
            $container.isotope('layout');
            /*jQuery('.block.video-gallery').css('min-height', jQuery('.block.video-gallery').outerHeight());*/
        });

        jQuery(window).load(function(){
            setPagination();
            goToPage(1);
        });

        jQuery('.filters a').click(function(){
            var filter = jQuery(this).attr(filterAtribute);
            currentFilter = filter;
            jQuery('.filters a').removeClass('active');
            jQuery(this).addClass('active');
            setPagination();
            goToPage(1);
        });
    }

}

function changeFilter(selector) {
    $container.isotope({
        filter: selector
    });
}


function goToPage(n) {
    currentPage = n;

    var selector = itemSelector;
    selector += ( currentFilter != '*' ) ? '['+filterAtribute+'="'+currentFilter+'"]' : '';
    selector += '['+pageAtribute+'="'+currentPage+'"]';

    changeFilter(selector);
}

function defineItemsPerPage() {
    var pages = itemsPerPageDefault;

    for( var i = 0; i < responsiveIsotope.length; i++ ) {
        if( jQuery(window).width() <= responsiveIsotope[i][0] ) {
            pages = responsiveIsotope[i][1];
            break;
        }
    }

    return pages;
}

function setPagination() {

    var SettingsPagesOnItems = function(){

        var itemsLength = $container.children(itemSelector).length;

        var pages = Math.ceil(itemsLength / itemsPerPage);
        var item = 1;
        var page = 1;
        var selector = itemSelector;
        selector += ( currentFilter != '*' ) ? '['+filterAtribute+'="'+currentFilter+'"]' : '';

        $container.children(selector).each(function(){
            if( item > itemsPerPage ) {
                page++;
                item = 1;
            }
            jQuery(this).attr(pageAtribute, page);
            item++;
        });

        currentNumberPages = page;

    }();

    var CreatePagers = function() {

        var $isotopePager = ( jQuery('.'+pagerClass).length == 0 ) ? jQuery('<div class="'+pagerClass+'"></div>') : jQuery('.'+pagerClass);

        $isotopePager.html('');

        for( var i = 0; i < currentNumberPages; i++ ) {
            var $pager = jQuery('<a href="javascript:void(0);" class="pager" '+pageAtribute+'="'+(i+1)+'"></a>');
            $pager.html(i+1);

            $pager.click(function(){
                var page = jQuery(this).eq(0).attr(pageAtribute);
                jQuery('.pager').removeClass('active');
                jQuery(this).addClass('active');
                goToPage(page);
            });

            $pager.appendTo($isotopePager);
        }

        $container.after($isotopePager);
        jQuery('.pager:first-of-type').addClass('active');

    }();

}

//Evento Responsivo
jQuery(window).resize(function(){
    if(jQuery('.video-gallery-wrapper')[0]){
        itemsPerPage = defineItemsPerPage();
        setPagination();
        goToPage(1);
    };
});
